// extracted by mini-css-extract-plugin
export default {"meinian-image-detail-box-wrapper":"index_meinian-image-detail-box-wrapper__-UUmQ","shrink":"index_shrink__ESbN4"};